import { atom } from "jotai";
import {
	applyLocale,
	readLocale,
	type SupportedLocale,
	writeLocale,
} from "../lib/locale";

// 결정적 기본값 — 실제 값은 getRouter(초기: URL 프리픽스 ?? en)와 __root beforeLoad가
// 내비게이션마다 set 한다. 저장된 선호/브라우저 언어를 여기서 읽으면 서버 HTML과
// 클라이언트 첫 렌더가 어긋나 hydration이 깨진다 — 그 적용은 LocaleSync(마운트 후).
export const localeAtom = atom<SupportedLocale>("en");

// locale 인자: 호출부(LocaleSync)가 라우터 상태 기준으로 이미 판정한 값을 넘길 수
// 있게 한다 — 내부에서 readLocale()을 재호출하면 window.location 레이스에 노출됨.
export const initializeLocaleAtom = atom(
	null,
	(_get, set, locale?: SupportedLocale) => {
		const resolved = locale ?? readLocale();
		applyLocale(resolved);
		set(localeAtom, resolved);
		return resolved;
	},
);

export const setLocaleAtom = atom(
	null,
	(_get, set, locale: SupportedLocale) => {
		writeLocale(locale);
		applyLocale(locale);
		set(localeAtom, locale);
	},
);
